export default __webpack_public_path__ + "static/media/covidTracker.43ff3ce3.png";